import { useGetAdmissionChecklistPendingSignOffsQuery } from "../../../services/api/formsApi";

interface Props {
  currentPage: number;
}

export function useHandleChecklistPendingSignOffs({ currentPage }: Props) {
  const { data, isLoading } = useGetAdmissionChecklistPendingSignOffsQuery({
    page: currentPage,
  });

  return { data, isLoading };
}
